import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AppRoot } from "@mydailydirect/app-kit";
import { App } from "./App";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppRoot appName="My Daily Direct" subtitle="Order Direct" roleLabel="Retailer" roles={["RETAILER"]} designDirection="navy">
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AppRoot>
  </StrictMode>,
);
